import { customElement } from "lit/decorators.js";
import { Subheading } from "@/components/subheading";

@customElement("eko-divider-title")
export class DividerTitle extends Subheading {
  constructor() {
    super();
    this.as = "span";
    this.size = "xl";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-divider-title": DividerTitle;
  }
}

export default DividerTitle;
